<template>
  <modal
    :name="modalName"
    resizable adaptive
    draggable=".window-header"
    @opened="opened"
    width="600"
    height="auto"
    :scrollable="false"
  >
  <div class="popup_wrap">

    <!-- height="470" -->
    <!-- https://github.com/euvl/vue-js-modal -->

    <!-- 날짜기준 없이 현시점 기준 전체 회원검색 -->
    <h5 class="pop_tit window-header"><!-- 타이틀바 -->
     {{ joinmode == 'Y' || joinmode == 'JD' ? '사무소 검색' : '회원검색' }}
    </h5>
     <span class="pop_close d2" @click="doClose"></span><!-- 닫기 -->


    <div class="sch_name_wrap ">
       <b class="subtit mr5">{{joinmode == 'Y' || joinmode == 'JD' ? '사무소명' : '회원명'}}</b>
      <input type="text" v-model="search.kword" @keyup.enter="doSearch(1)" title="검색" placeholder="검색" />
      <a @click="doSearch(2)" class="btn icon search_black" >검색</a>
      <a @click="doInit" class="btn icon reload ml2 " >초기화</a>
    </div>

    <!-- 타회소속 입력 가능 옵션인 경우 -->
    <div v-if="search.guestyn == 'Y'" class="check_wrap">
        <label class="subtit">
          <input type="checkbox" v-model="use_other_memb" :true-value="true" :false-value="false" />
          타회 소속 회원 직접입력
        </label>
        <template  v-if="use_other_memb">
          <br/>
          <dt>이름</dt><dd><i-input      v-model="other_memb.knm" placeholder="이름"/></dd>
           <!--<dt>생년월일</dt><dd> <i-input-date v-model="other_memb.birthday" input-class="w_inputno" /></dd> 20230324 최동현 요청 생년월일 제외-->

          <dt>등록번호</dt><dd> <i-input      v-model="other_memb.membno"  placeholder="등록번호"/> <i-btn @click="guestInputOk(other_memb)" class="btn  black01 xs outline">입력완료</i-btn></dd>

        </template>
    </div>
    <s-table3
      unitName  = "건"
      ref       = "main"
      :list.sync = "list"
      @itemClick = "doClick"
      @loadData  = "getDataList"
    >

      <template v-slot:item.added="{item, i}"> {{ isSelected(item.membno) }} </template>

    </s-table3>

  </div><!--//popup_wrap -->
  </modal>
</template>

<script>

let ui
const isDebug = true
export default {
  props: {
    officeclsf: { default: ''},
    officeno: { default: ''},
    memblist: {
        type: Array,
        // default: ()=>[],   // undefined 체크를 위해서 기본값 삭제 ( 회원 여려명 선택기능 사용 안할때 대비 )
    },
  },
  data () {
    return {
      modalName: "c회원선택_" + T.randomAZ(10),
      defaultKword: null,
      menu : '',
      reptyy : '',
      joinmode: '',
      search : {}, // 검색 변수
      search_init : { // 검색 변수
        kword : '',
        iv_membclsf : '',
        guestyn : '',
        knm: '',
        birthday: '',
        membno: '',
        adddt: '', // 신동호
      },
      use_other_memb : false, // 타회 소속 입력박스 선택
      other_memb : { // 타회 소속
        guestyn  : 'Y',
        membclsf : 'P',
        knm      : '',
        birthday : '',
        membno   : '',
      },
      // 목록 전용 변수
      // totpages: 0,
      list: {
        headers: T.makeJson(`
          text         | value      |  width  | align
          (default)    |            |         | center
          회원명       | knm        | 150
          등록번호     | membno     |  70
          사무실명     | officename |
        ` + ((this.memblist !== undefined) ?     // memblist 가 사용되는 경우에만 추가여부를 보여준다.
        ' 추가여부     | added      |  80' : '')),
      }
    }
  },
  created() {
    // console.clear()
    // var array =  [{a:1}, {a:2}, {a:3}]
    // var ret = _.some(array, { a:1 })
    console.log("memblist = ", this.memblist);
    // console.log("ret = ", ret);

    isDebug && console.log("[c회원선택] created()")
    ui = this.$ui;
    // this.modalName = "c회원선택_" + T.randomAZ(10)
  },
  methods : {

    open(iv_membclsf, defaultKword, cntchargdt, guestyn = 'N', joinmode = 'N', menu = '', reptyy = '') {

      this.search = _.clone(this.search_init)
      this.list = { headers: this.list.headers } // 데이터 초기화 (필수 )
      this.menu = menu
      this.reptyy = reptyy

      this.defaultKword = defaultKword
      this.search.iv_membclsf = iv_membclsf
      this.search.guestyn = guestyn // 타회소속 직접입력 여부
      this.joinmode  = joinmode // 회원가입화면 여부
      console.log("joinmode  = ", joinmode);
      console.log("this.joinmode  = ", this.joinmode);
      isDebug && console.log("[c회원선택] open() defaultKword = ", defaultKword, ", this.defaultKword = ", this.defaultKword);
      this.$modal.show(this.modalName); // opened() call
    },
    opened() {
      isDebug && console.log("[c회원선택] opened()")

      this.doInit({focusDelay: 200}) // 화면이 열리자 마자 포커스를 주게되면
                      // 부모에서 앤터키 눌러서 들어온 경우 앤터키가 전파되어 검색을 두번하게 된다.
                      // 그래서 200ms 이후에 포커스를 준다.

      // console.log("오픈 : "+ defaultKword)
      if (this.defaultKword) { // 키워드가 넘어온 경우
        // console.log("오픈1")
        this.search.kword = this.defaultKword
        this.doSearch(3)
      } else {
        // console.log("오픈2")
        this.search.kword = ''
      }

      if(this.menu == 'reportcaymy'){
        this.search.kword = this.defaultKword
        this.doSearch(4)
      }
    },
    doInit ({focusDelay=1}) {
      isDebug && console.log("[c회원선택] doInit1()");
      this.search.kword = ''
      this.search.knm = ''
      this.$refs.main.clear()
      setTimeout(()=>this.doInitFocus(), focusDelay)
    },
    doInitFocus() {
      // opened() 전에는 refs 가 없을 수 있다.
      if (this.$refs.kword && this.$refs.kword.$el) {
        if (this.$refs.kword.$el.focus) { this.$refs.kword.$el.focus(); return }
        this.$refs.kword.$el.getElementsByTagName("input")[0].focus()
      }
    },
    doClose () {
      this.$modal.hide(this.modalName);
    },
    doSearch (no, e) {
      isDebug && console.log("[c회원선택] doSearch : no =", no, ", e =", e)
      this.$refs.main.load()
    },
    getDataList () {

      // if (!this.search.kword) {
      //   ui.alert('검색어를 입력하세요').then(() => { this.doInitFocus() })
      //   this.doInit()
      //   return
      // }
      let list = this.list
      list.loading = true

      ui.httpGet(this.joinmode == 'Y' || this.joinmode == 'JD' ? '/public/proc/N_MEMB_LIST_JOIN' : '/proc/N_MEMB_LIST_NOW', {
          iv_menu       : this.menu || '',
          iv_pgsize     : list.pageSize,
          iv_page       : list.pageNo,
          iv_membnm     : this.search.kword || '',   // 회원명
          iv_membclsf   : this.joinmode == 'JD' ? 'JD' : this.search.iv_membclsf, // 회원구분
          iv_officeclsf : this.officeclsf,
          iv_officeno   : this.officeno,
          iv_reptyy     : this.reptyy,
        }, ret => {
        // console.log("ret.data.rs1[0]", ret.data.rs1[0])
        // console.log("ret.data.rs2", ret.data.rs2)
        // const {tot_rows, tot_pages} = ret.data.rs1[0]

        const {tot_rows} = ret.data.rs1[0]
        list.totalCount  = tot_rows;
        list.items       = ret.data.rs2

        if (tot_rows == 0)
          ui.toast("결과가 없습니다")
        if (tot_rows == 1) { // 결과가 하나인 경우
          this.doClick(list.items[0])
        }
      }, null, v=>list.loading = false)
    },
    guestInputOk(item) { // 타회소속 입력 완료버튼

      // 이름 필수체크
      if (T.isEmpty(item.knm)){
        return ui.alert("이름을 입력해 주세요.")
      }

      // 생년월일 필수체크 20230324 최동현 제외 요청
      //if (T.isEmpty(item.birthday)){
      //  return ui.alert("생년월일을 입력해 주세요.")
     // }

      this.doClick({
        ...item,
        birthday : item.birthday.replace(/-/g, '')
      })

    },
    doClick (item, $event) { // 선택

      const ctrl_press = !!($event && $event.ctrlKey) // 컨트롤 클릭 여부


      // console.log(already);
      // console.log("item : " + item.membno);
      // console.log("$event : ", $event);
      // console.log("$event.ctrlKey : ", $event.ctrlKey);

      item.membnm = item.knm
      // console.log("item = ", item);

      this.$emit("select", {...item})

      if (ctrl_press == false) {// 컨트롤 클릭이 아니라면 close
        this.doClose()
      }

    },
    isSelected(membno){

      if (this.memblist === undefined) return ''

      const already = _.some(this.memblist, {membno : membno}) // 선택되었는지 여부
      if(already) {
        return "추가됨"
      }
      else {
        return "-"
      }
    }
  }
}
</script>
<style scoped>
  .sch_name_wrap { margin:10px 10px; width:100%; box-sizing: border-box; padding-right:10px;}
  .sch_name_wrap .subtit { line-height: 34px;   font-size:14px; font-weight: 700; float:left;}

  .check_wrap { margin:10px 0; padding:5px 10px; background-color: #eee;  line-height:33px; display: inline-block; width:100%; box-sizing: border-box}

  .check_wrap label, .check_wrap span, .check_wrap dt, .check_wrap dd { float:left; }
  .check_wrap label { margin-right:5px; font-weight: bold}
  .check_wrap dt { margin:0 5px; font-weight: bold}
  .check_wrap dt:first-child { margin-left:0;}
  .check_wrap dd input { max-width:60px;}

  @media screen and (max-width:640px){
    .sch_name_wrap {min-width:200px;}
      .sch_name_wrap input  {  width:100px;}
      .check_wrap  { margin:10px 0; letter-spacing: -1px;}

      .check_wrap dt { display:none; }
      .check_wrap dd input { max-width:80px;}
      /* .check_wrap dd { width:80px;} */
      /* .check_wrap dd input { width:100px} */


  }
</style>
